module.exports = __webpack_public_path__ + "img/er2.06d765ec.png";